const subscriptionType = [
    { key: "PAID", value: "PAID" },
    { key: "FREE", value: "FREE" },
];

export { subscriptionType };